import {
	HomeIcon,
	UserGroupIcon,
	UserIcon,
	HeartIcon,
	MagnifyingGlassIcon,
	UserCircleIcon,
} from "@heroicons/react/24/outline";
import React, { useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { PathName } from "routers/types";
import MenuBar from "shared/MenuBar/MenuBar";
import isInViewport from "utils/isInViewport";
import AlltaTextLogo  from '../../assets/logo/allta_text.png';

let WIN_PREV_POSITION = window.pageYOffset;

interface NavItem {
	name: string;
	link?: PathName;
	icon: any;
}

const NAV: any = [
	{
		type: "menu",
		name: "홈",
		link: "/home",
		icon: HomeIcon,
	},
	{
		type: "menu",
		name: "커뮤니티",
		link: "/community",
		icon: UserGroupIcon,
	},
	{
		type: "icon",
	    name: "Menu",
		link: "/intro",
	    icon: MenuBar,
	},
	{
		type: "menu",
		name: "내예약",
		link: "/reservation",
		icon: HeartIcon,
	},
	{
		type: "menu",
		name: "내정보",
		link: "/me",
		icon: UserCircleIcon,
	},
];

const FooterNav = () => {
	const containerRef = useRef<HTMLDivElement>(null);
	//

	const location = useLocation();

	useEffect(() => {
		window.addEventListener("scroll", handleEvent);
	}, []);

	const handleEvent = () => {
		//window.requestAnimationFrame(showHideHeaderMenu);
	};

	const showHideHeaderMenu = () => {
		let currentScrollPos = window.pageYOffset;
		if (!containerRef.current) return;

		// SHOW _ HIDE MAIN MENU
		if (currentScrollPos > WIN_PREV_POSITION) {
			if (
				isInViewport(containerRef.current) &&
				currentScrollPos - WIN_PREV_POSITION < 80
			) {
				return;
			}

			containerRef.current.classList.add("FooterNav--hide");
		} else {
			if (
				!isInViewport(containerRef.current) &&
				WIN_PREV_POSITION - currentScrollPos < 80
			) {
				return;
			}
			containerRef.current.classList.remove("FooterNav--hide");
		}

		WIN_PREV_POSITION = currentScrollPos;
	};

	return (
		<div
			ref={containerRef}
			className="FooterNav h-[55px] p-[4px] bg-white dark:bg-neutral-800 fixed top-auto bottom-0 inset-x-0 z-30 border-t border-neutral-300 dark:border-neutral-700 
      transition-transform duration-300 ease-in-out"
		>
			<div className="w-full max-w-lg flex justify-around mx-auto text-sm text-center">
				{/* MENU */}
				{NAV.map((item: any, index: number) => {
					
					const active = location.pathname === item.link;
					
					return item.type==="menu" ? (
						<Link
							key={index}
							to={item.link}
							className={`flex flex-col !items-center space-y-1 justify-center text-neutral-600 dark:text-neutral-300/90 ${active ? "text-red-600 dark:text-neutral-100" : ""}`}
						>
							<item.icon
								className={`w-6 h-6 ${active ? "text-red-600" : ""}`}
							/>
							<span className="text-[12px] leading-none">{item.name}</span>
						</Link>
					) : (
						<Link
							key={index}
							to={item.link}
							className={`flex flex-col !items-center space-y-1 justify-center text-neutral-600 dark:text-neutral-300/90 ${active ? "text-red-600 dark:text-neutral-100" : ""}`}
						>
							<div
								className={`flex flex-col items-center justify-between text-neutral-500 dark:text-neutral-300/90 rounded-2xl bg-black p-2 ${active ? "text-neutral-900 dark:text-neutral-100" : ""
									}`}
							>
								<img className={"h-[30px] sm:h-[30px]"} src={AlltaTextLogo} />
								{/* <span className="text-[11px] leading-none mt-1">{item.name}</span> */}
							</div>
						</Link>
					);
				})}
			</div>
		</div>
	);
};

export default FooterNav;
